import { useState } from 'react';
import NotificationsTrigger from '../../react/components/Notifications/NotificationsTrigger/withProvider';
import GlobalCreate from '../../react/features/AppHeader/components/GlobalCreate';
import HelpMenu from '../../react/features/AppHeader/components/HelpMenu';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import HeaderSearchBar from '../../react/features/HeaderSearchBar/container';
import { useAppContext } from '../../react/hooks/useAppContext';
import styles from './style.m.less';

export default function Actions() {
    const [searchFocused, setSearchFocused] = useState(false);
    const { user } = useAppContext();

    return (
        <div className={styles.container}>
            <div className={styles.actions}>
                {!user.isGuest && (
                    <>
                        {!searchFocused && <GlobalCreate user={user} />}
                        <HeaderSearchBar
                            onFocus={() => setSearchFocused(true)}
                            onBlur={() => setSearchFocused(false)}
                        />
                    </>
                )}
                {!searchFocused && (
                    <>
                        <HelpMenu />
                        <NotificationsTrigger />
                    </>
                )}
            </div>
            <UserMenu user={user} />
        </div>
    );
}
